export const MICROPHONE_REQUIRED_INFO = `To join the chat, access to your camera and microphone is required. Click on the camera icon in the address bar. It may be helpful to refresh the page.`
export const LOADER_TEXT = 'Obtaining Video Conference data'
